import { symbols } from "..";

// --------------------------------------
export const bloggersSizes = [
  { id: "small", title: "Маленький (до 5 000 подписчиков)", value: [0, 5000] },
  { id: "medium", title: "Средний (от 5 000 до 50 000 подписчиков)", value: [5000, 50000] },
  { id: "large", title: "Крупный (от 50 000 подписчиков)", value: [50000, Infinity] },
];
export const getBloggerSizeTitle = subCount => {
  const size = bloggersSizes.find(item => subCount >= item.value[0] && subCount < item.value[1]);
  return size.title || symbols.none;
};
// ------------------
export const successLevelOptions = [
  { id: 0, title: "Низкая" },
  { id: 1, title: "Средняя" },
  { id: 2, title: "Высокая" },
  { id: 3, title: "Очень высокая" },
];
//
export const getSuccessLevelTitle = id => {
  if (isNaN(id)) return symbols.none;
  const level = successLevelOptions.find(item => item.id == id) || {};
  return level.title || symbols.none;
};
// -------------------------------------------

export const externalTrafficOptions = [
  { id: "any", title: "Любое", serverValue: undefined },
  { id: "low", title: "Не выявлено", serverValue: false },
  { id: "high", title: "Высокое", serverValue: true },
];
